import { render } from "./FlashCash.vue?vue&type=template&id=1163960b&scoped=true"
import script from "./FlashCash.vue?vue&type=script&lang=js"
export * from "./FlashCash.vue?vue&type=script&lang=js"

import "./FlashCash.vue?vue&type=style&index=0&id=1163960b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1163960b"]])

export default __exports__